import { render, staticRenderFns } from "./CompGeneralTooltip.vue?vue&type=template&id=17555b48&scoped=true"
import script from "./CompGeneralTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGeneralTooltip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompGeneralTooltip.vue?vue&type=style&index=0&id=17555b48&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17555b48",
  null
  
)

export default component.exports